import { PROJECT_REQUIRED_ERROR } from '@schemas/createTaskFormSchema';

export type SubmitButtonBg = 'grey04' | 'greenDark' | 'greenSecondary';

interface SubmitStateInput {
  isValid: boolean;
  isSubmitting: boolean;
  name: string;
  projectId?: string | null;
  loadingTasksNameData: boolean;
  errors: Record<string, unknown>;
}

export const getTaskCreateSubmitState = ({
  isValid,
  isSubmitting,
  name,
  projectId,
  loadingTasksNameData,
  errors,
}: SubmitStateInput) => {
  const isOnlyProjectRequiredError =
    !!errors &&
    Object.keys(errors).length === 1 &&
    errors.projectId === PROJECT_REQUIRED_ERROR;

  const showDisabledBg =
    !isValid ||
    isSubmitting ||
    !name.trim() ||
    !projectId ||
    loadingTasksNameData;

  const isDisabled =
    (!isValid && !isOnlyProjectRequiredError) ||
    isSubmitting ||
    !name.trim() ||
    loadingTasksNameData;

  return { isDisabled, showDisabledBg };
};

export const getSubmitButtonBg = (
  showDisabledBg: boolean,
  pressed: boolean
): SubmitButtonBg => {
  if (showDisabledBg) return 'grey04';
  return pressed ? 'greenDark' : 'greenSecondary';
};

// TA-10210: the submit icon becomes a spinner while the create-task request
// (or the pre-submit file upload it waits on) is in flight.
export const shouldShowSubmitSpinner = (
  isSubmitting: boolean,
  isReadySubmitting: boolean
): boolean => isSubmitting || isReadySubmitting;
